import { connect } from 'react-redux';
import GenericLoader from '../util/GenericLoader';
import {
  fetchEquipForBuildingActionCreator,
  fetchEquipForAllBuildingsActionCreator,
} from '../../redux/actions/equipment';

const mapDispatchToProps = (dispatch, { org, buildingId, getPoints, getDevices }) => ({
  fetchFunction: () => {
    if (buildingId)
      dispatch(fetchEquipForBuildingActionCreator(buildingId, getPoints, getDevices)).catch(
        () => {}
      );
    if (org) dispatch(fetchEquipForAllBuildingsActionCreator(org, getPoints, getDevices));
  },
});

export default connect(null, mapDispatchToProps)(GenericLoader);
